export default __webpack_public_path__ + "static/media/latest-html-semantics.eb9df5a0.svg";